import { cloneDeep } from 'lodash'

import {
  CreateCashRegisterModel,
  CashRegisterModel,
  CashRegistersState,
  UpdateCashRegisterModel,
} from './types'

export default abstract class CashRegistersCore {
  cashRegisters: Array<CashRegisterModel>

  constructor(cashRegisters: Array<CashRegisterModel>) {
    this.cashRegisters = cashRegisters
  }

  getSequenceNumber(id: number): number | null {
    const payment = this.getCashRegister(id)

    if (payment) {
      const cash = payment.state === CashRegistersState.Active ? this.activePayments : this.hiddenPayments

      const index = cash.findIndex((i) => i.id === id)

      return index === -1 ? null : index + 1
    }
    return null
  }

  get activePayments(): Array<CashRegisterModel> {
    return this.cashRegisters.filter((p) => p.state === CashRegistersState.Active)
  }

  get hiddenPayments(): Array<CashRegisterModel> {
    return this.cashRegisters.filter((p) => p.state === CashRegistersState.Hidden)
  }

  getCashRegister(id: number): CashRegisterModel | undefined {
    return this.cashRegisters.find((p) => p.id === id)
  }

  PSIndex(id: number): number {
    return this.cashRegisters.findIndex((p) => p.id === id)
  }

  createCashRegisterHandler(system: CreateCashRegisterModel) {
    return this.createCashRegister(system)
      .then((cashRegister) => {
        if (cashRegister) {
          this.cashRegisters.unshift(cashRegister)

          return cashRegister
        }
      })
  }

  updateCashRegistersHandler(cashRegister: UpdateCashRegisterModel, changedCredentials: boolean) {
    const copy = cloneDeep(cashRegister)

    if (!changedCredentials) {
      delete copy.data
    }

    return new Promise<void | Array<CashRegisterModel>>(resolve => {
      const index = this.PSIndex(copy.id)

      if (index !== -1) {
        this.updateCashRegisters(copy)
          .then((cashRegister) => {
            if (cashRegister) {
              this.cashRegisters.splice(index, 1, cashRegister)

              resolve(this.cashRegisters)
            } else {
              resolve()
            }
          })
      }
    })
  }

  deleteCashRegistersHandler(id: number) {
    return new Promise<void | CashRegistersState>(resolve => {
      const index = this.PSIndex(id)

      if (index !== -1) {
        this.deleteCashRegisters(id)
          .then((state) => {
            if (state) {
              if (state === CashRegistersState.Removed) {
                this.cashRegisters.splice(index, 1)
              } else {
                this.cashRegisters[index].state = state
              }

              resolve(state)
            } else {
              resolve()
            }
          })
      }
    })
  }

  restoreCashRegisterHandler(id: number): void {
    const payment = this.getCashRegister(id)

    if (payment) {
      this.restoreCashRegister(id)
        .finally(() => payment.state = CashRegistersState.Active)
    }
  }

  protected abstract restoreCashRegister(id: number): Promise<void>
  protected abstract createCashRegister(system: CreateCashRegisterModel): Promise<CashRegisterModel | void>
  protected abstract updateCashRegisters(system: UpdateCashRegisterModel): Promise<CashRegisterModel | void>
  protected abstract deleteCashRegisters(id: number): Promise<CashRegistersState | void>
}
